function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Drawer, Divider, Button, List, notification, Modal, Statistic, Tag, Space } from "antd";
import Common from "../components/includes/Common";
import AddEmployee from "../components/forms/AddEmployee";
import { PersonFillAdd, Cash, PencilFill, SlashCircleFill, CardImage, CheckCircleFill, XCircleFill, CardHeading, FolderFill, TrashFill, PrinterFill } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import EditEmployee from "../components/forms/EditEmployee";
import Card from "../components/Card";
import { Table } from "react-bootstrap";
import AddEmployeeContract from "../components/forms/AddEmployeeContract";
import AddEmployeeAvatar from "../components/forms/AddEmployeeAvatar";
import EmployeeDetails from "../components/EmployeeDetails";
import SalarySheet from "../components/SalarySheet";
import DisplaySalarySheet from "../components/DisplaySalarySheet";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Hr = function Hr() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    depList = _useState2[0],
    setDepList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataChanged = _useState6[0],
    setIsDataChanged = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showNewEmployee = _useState0[0],
    setShowNewEmployee = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    employees = _useState10[0],
    setEmployees = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showPrint = _useState12[0],
    setShowPrint = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showEdit = _useState14[0],
    setShowEdit = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedItem = _useState16[0],
    setSelectedItem = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showNewContract = _useState18[0],
    setShowNewContract = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showAddAvatar = _useState20[0],
    setShowAddAvatar = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showEmployeeDetails = _useState22[0],
    setShowEmployeeDetails = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showSalaryState = _useState24[0],
    setShowSalaryState = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    salarySheets = _useState26[0],
    setSalarySheets = _useState26[1];
  var _useState27 = useState(24),
    _useState28 = _slicedToArray(_useState27, 2),
    limite = _useState28[0],
    setLimite = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    offset = _useState30[0],
    setOffset = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    selectedSheet = _useState32[0],
    setSelectedSheet = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showSheet = _useState34[0],
    setShowSheet = _useState34[1];
  var ref = useRef();
  var mar = ["JANVIER", "FEVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DECEMBRE"];
  var handleApprove = function handleApprove(s) {
    setSelectedSheet(s);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La validation de l'\xE9tat pour le mois de ", mar[s.month], " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvesalarysheet", {
          id: s.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleUnApprove = function handleUnApprove(s) {
    setSelectedSheet(s);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'invalidation de l'\xE9tat pour le mois de ", mar[s.month], " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "unapprovesalarysheet", {
          id: s.id,
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleDeleteSheet = function handleDeleteSheet(s) {
    setSelectedSheet(s);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression de l'\xE9tat pour le mois de ", mar[s.month], " ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deletesalarysheet", {
          user_id: Common.currentUser.id,
          id: s.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleExclude = function handleExclude(e) {
    setSelectedItem(e);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'exclusion de ", "".concat(e.firstname, " ").concat(e.lastname), " de l'\xE9tat des salaires ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "excludeemployee", {
          user_id: Common.currentUser.id,
          id: e.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleInclude = function handleInclude(e) {
    setSelectedItem(e);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'exclusion de ", "".concat(e.firstname, " ").concat(e.lastname), " de l'\xE9tat des salaires ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "includeemployee", {
          user_id: Common.currentUser.id,
          id: e.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setIsDataChanged(true);
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    setDepList([]);
    axios.get("".concat(Common.baseApiUrl, "getdepartments")).then(function (response) {
      if (response.data.status == 200) {
        setDepList(response.data.departments);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue. code: " + error.toString());
    })["finally"](function () {
      setIsDataChanged(false);
    });
  }, []);
  useEffect(function () {
    axios.get("".concat(Common.baseApiUrl, "getemployees/").concat(Common.currentUser.id)).then(function (response) {
      setEmployees([]);
      if (response.data.status == 200) {
        setEmployees(response.data.employees);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue. code: " + error.toString());
    })["finally"](function () {
      setIsDataChanged(false);
    });
  }, [isDataChanged]);
  useEffect(function () {
    setIsDataChanged(false);
    axios.get("".concat(Common.baseApiUrl, "getsalarysheets/").concat(limite, "/").concat(offset, "/").concat(Common.currentUser.id)).then(function (response) {
      setSalarySheets([]);
      if (response.data.status == 200) {
        setSalarySheets(response.data.sheets);
      } else {
        notification.error({
          message: "Erreur!",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {});
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 8,
          md: 8,
          children: [/*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            wrap: true,
            children: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                setShowNewEmployee(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PersonFillAdd, {
                  size: 20
                }), " AJOUTER UN(E) EMPLOYE(E)"]
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                setShowSalaryState(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Cash, {
                  size: 20
                }), " ETAT DES SALAIRES"]
              })
            })]
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Table, {
            children: [/*#__PURE__*/_jsx("thead", {
              children: /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("th", {
                  children: "Nom"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Prenom"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Poste"
                }), /*#__PURE__*/_jsx("th", {
                  children: "Contact"
                }), /*#__PURE__*/_jsx("td", {})]
              })
            }), /*#__PURE__*/_jsx("tbody", {
              children: employees.map(function (e) {
                return /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: e.lastname
                  }), /*#__PURE__*/_jsx("td", {
                    children: e.firstname
                  }), /*#__PURE__*/_jsx("td", {
                    children: e.job
                  }), /*#__PURE__*/_jsx("td", {
                    children: e.mobile
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx(Button, {
                        tye: "link",
                        onClick: function onClick() {
                          setSelectedItem(e);
                          setShowEdit(true);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(PencilFill, {
                            size: 18
                          })
                        })
                      }), /*#__PURE__*/_jsx(Button, {
                        tye: "link",
                        onClick: function onClick() {
                          setSelectedItem(e);
                          setShowNewContract(true);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(CardHeading, {
                            size: 18
                          })
                        })
                      }), /*#__PURE__*/_jsx(Button, {
                        tye: "link",
                        onClick: function onClick() {
                          setSelectedItem(e);
                          setShowAddAvatar(true);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(CardImage, {
                            size: 18
                          })
                        })
                      }), /*#__PURE__*/_jsx(Button, {
                        tye: "link",
                        onClick: function onClick() {
                          setSelectedItem(e);
                          setShowEmployeeDetails(true);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(FolderFill, {
                            size: 18
                          })
                        })
                      }), e.status == 1 ? /*#__PURE__*/_jsx(Button, {
                        tye: "link",
                        onClick: function onClick() {
                          handleExclude(e);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(SlashCircleFill, {
                            style: {
                              color: "#6B2E2E"
                            },
                            size: 18
                          })
                        })
                      }) : /*#__PURE__*/_jsx(Button, {
                        tye: "link",
                        onClick: function onClick() {
                          handleInclude(e);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: /*#__PURE__*/_jsx(CheckCircleFill, {
                            style: {
                              color: "#2E6B5B"
                            },
                            size: 18
                          })
                        })
                      })]
                    })
                  })]
                }, e.id);
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: salarySheets.map(function (s) {
            return /*#__PURE__*/_jsxs("div", {
              style: {
                marginBottom: "12px",
                color: "#424242",
                background: '#FFFFFF',
                padding: "16px",
                borderRadius: "3px",
                boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px"
              },
              children: [/*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsxs("b", {
                  children: [mar[s.month], " / ", s.year]
                })
              }), /*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Statistic, {
                    valueStyle: {
                      color: "#424242"
                    },
                    title: "Masse totale",
                    value: s.total,
                    prefix: "GNF"
                  })
                })
              }), s.status == 0 ? /*#__PURE__*/_jsx(Tag, {
                color: "#f50",
                children: "En cours de validation"
              }) : /*#__PURE__*/_jsx(Tag, {
                color: "#2E6B5B",
                children: "Valid\xE9"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedSheet(s);
                    setShowSheet(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(FolderFill, {
                      size: 18
                    })
                  })
                }), s.status == 0 ? /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    handleApprove(s);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(CheckCircleFill, {
                      style: {
                        color: "#2E6B5B"
                      },
                      size: 18
                    })
                  })
                }) : /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    handleUnApprove(s);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(XCircleFill, {
                      style: {
                        color: "#6B2E2E"
                      },
                      size: 18
                    })
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    handleDeleteSheet(s);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(TrashFill, {
                      size: 18
                    })
                  })
                })]
              })]
            }, s.id);
          })
        })]
      })
    }), showNewEmployee && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "AJOUTER UN(E) EMPLOYE(E)"
        }),
        width: "370px",
        destroyOnClose: true,
        open: showNewEmployee,
        onClose: function onClose() {
          setShowNewEmployee(false);
        },
        children: /*#__PURE__*/_jsx(AddEmployee, {
          handler: function handler() {
            setIsDataChanged(true);
            setShowNewEmployee(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      })
    }), selectedItem != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER UN(E) EMPLOYE(E)"
        }),
        width: "370px",
        destroyOnClose: true,
        open: showEdit,
        onClose: function onClose() {
          setShowEdit(false);
        },
        children: /*#__PURE__*/_jsx(EditEmployee, {
          employee: selectedItem,
          handler: function handler() {
            setIsDataChanged(true);
            setShowEdit(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "CARTE VITALE"
        }),
        width: "60%",
        open: showPrint,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        onClose: function onClose() {
          setShowPrint(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(Card, {
          ref: ref,
          candidat: selectedItem
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "AJOUTER UN CONTRAT"
        }),
        width: "350px",
        destroyOnClose: true,
        open: showNewContract,
        onClose: function onClose() {
          setShowNewContract(false);
        },
        children: /*#__PURE__*/_jsx(AddEmployeeContract, {
          employee: selectedItem,
          handler: function handler() {
            setIsDataChanged(true);
            setShowNewContract(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "AJOUTER LA PHOTO DE L'EMPLOYE(E)"
        }),
        width: "50%",
        style: {
          minHeight: "350px"
        },
        footer: null,
        destroyOnClose: true,
        open: showAddAvatar,
        onCancel: function onCancel() {
          setShowAddAvatar(false);
        },
        children: /*#__PURE__*/_jsx(AddEmployeeAvatar, {
          employee: selectedItem,
          handler: function handler() {
            setIsDataChanged(true);
            setShowAddAvatar(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS EMPLOYE(E)"
        }),
        width: "70%",
        destroyOnClose: true,
        open: showEmployeeDetails,
        onClose: function onClose() {
          setShowEmployeeDetails(false);
        },
        children: /*#__PURE__*/_jsx(EmployeeDetails, {
          employee: selectedItem,
          handler: function handler() {
            setIsDataChanged(true);
            setShowEmployeeDetails(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "ETAT DES SALAIRES"
      }),
      width: "80%",
      destroyOnClose: true,
      open: showSalaryState,
      onClose: function onClose() {
        setShowSalaryState(false);
      },
      children: /*#__PURE__*/_jsx(SalarySheet, {
        employees: employees.filter(function (e) {
          return e.status == 1;
        }),
        handler: function handler() {
          setIsDataChanged(true);
          setShowSalaryState(false);
        }
      })
    }), selectedSheet && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["ETAT DE ", mar[selectedSheet.month], " / ", selectedSheet.year]
      }),
      width: "80%",
      destroyOnClose: true,
      open: showSheet,
      onClose: function onClose() {
        setShowSheet(false);
      },
      extra: /*#__PURE__*/_jsx(Space, {
        children: /*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                size: "large",
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PrinterFill, {
                    size: 22
                  }), " IMPRIMER"]
                })
              });
            }
          })
        })
      }),
      children: /*#__PURE__*/_jsx(DisplaySalarySheet, {
        ref: ref,
        sheet: selectedSheet
      })
    })]
  });
};
export default Hr;